import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setExperimentsReady } from '../../redux/actions/experiments';
import amplitudeAnalytics from '../../shared/utilities/amplitude';
import {
  fetchAmplitudeExperimentVariants,
  isExperimentClientReady,
} from '../../shared/utilities/amplitudeExperiment';

const ExperimentProvider = ({ children }) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user?.userId ?? null);

  useEffect(() => {
    let cancelled = false;

    const syncVariants = async () => {
      dispatch(setExperimentsReady(false));
      try {
        if (cancelled) {
          return;
        }
        if (!isExperimentClientReady()) {
          return;
        }
        amplitudeAnalytics.syncUserId(userId);
        await amplitudeAnalytics.getReadyPromise();
        await fetchAmplitudeExperimentVariants();
      } finally {
        if (!cancelled) {
          dispatch(setExperimentsReady(true));
        }
      }
    };

    syncVariants();

    return () => {
      cancelled = true;
    };
  }, [dispatch, userId]);

  return children;
};

ExperimentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ExperimentProvider;
